/* src/app/components/doc-viewer-new/doc-viewer-content/doc-viewer-pdf-content/pdf-viewer/pdf-viewer.component.scss */
input {
  width: 24px;
  opacity: 85%;
  border-radius: 5px;
  padding: 4px;
  border: 1px solid rgba(120, 120, 120, 0.6196078431);
  outline: none;
  color: inherit;
  background: inherit;
  text-align: center;
  transition: box-shadow 0.2s;
}
input:focus {
  border-color: #D0A010;
  box-shadow: 0 0 3px #b18a16;
}
/*# sourceMappingURL=pdf-viewer.component.css.map */
